import React from 'react';
import { Link } from "react-router";
import Storage from '../../../utility/features/helpers/storageHelper';
import { URLS } from "../../../utility/constants/appConstants";
import successStyles from "../../../styles/SuccessMessage.module.scss";

const SuccessMessage = ({ title, message, btnText, btnLink, btnElement, labels, email }) => {
  window.scrollTo(0, 0);
  const queryString = window.location.search != ""?window.location.search:"";
  if(labels) {
    title = title || labels.passChangeSuccess;
    message = message || labels.beSure;
    btnText = btnText || labels.returnToAccount;
    btnLink = btnLink || URLS.settings;
  }

  if(typeof message === 'string'){
    message = message.replace('{EMAIL}', email || Storage.email() || '');
  }
  
  return (
    <div>
      <div className='bg-gray-100 mb-40 p-md-30 mb-40 tru-mma-main-wrapper tru-mma-main-wrapper--summary'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 p-0 text-center'>
              <div className={`${successStyles["success-title"]} mx-auto`}>
                {title}
              </div>
              <div className={successStyles['my-30']}>
                <img
                  src='/images/check-circle-solid.svg'
                  alt='Success'
                  style={{maxWidth: "160px", height: "auto"}}
                />
              </div>
              <div className={`${successStyles["success-msg"]}`}>
                {message}
              </div>
              {btnElement ? btnElement : (
                <div className='text-center'>
                  <Link className={`${successStyles['btn-orange']}`} to={btnLink + queryString} >
                    {btnText}
                  </Link>
                </div>
              )}  
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessMessage;
